export const partners = [
  {
    name: "Textile Innovation Exchange (TIE)",
    description:
      "A separate Bangladesh-rooted global innovation platform. TIE collaborates with Textile Today Innovation Hub on relevant innovation initiatives.",
    website: "https://textileinnovationexchange.com/",
  },
  {
    name: "Alibaba",
    description:
      "Strategic partnership for industry promotion, B2B engagement and market visibility initiatives.",
    website: "https://www.alibaba.com/",
  },
  {
    name: "Ecopsis",
    description:
      "Collaboration on research, consultancy and industry solution development.",
    website: "https://ecopsis.com/",
  },
];